import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import PromoteEventHero from './components/PromoteEventHero';
import PromotionPricing from './components/PromotionPricing';
import PromotionExamples from './components/PromotionExamples';
import PromotionForm from './components/PromotionForm';

export default function PromoteEventPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <PromoteEventHero />
      <PromotionPricing />
      <PromotionExamples />
      <PromotionForm />
      <Footer />
    </div>
  );
}